module.exports = __webpack_public_path__ + "static/media/add-new-point.0a9ce62a.png";